import React, { useMemo, useState } from "react";

interface Props {
  stepData: any;
  onSkip: (assessId: string, stepId: string) => void;
  onSubmit: (endpoint: string, payload: any[]) => void;
}

const RangeOfMotion: React.FC<Props> = ({ stepData, onSkip, onSubmit }) => {

  const assessId = stepData.assessment_id;
  const stepId = stepData.current_step;

  // ✅ Active joint (default first)
  const [activeJoint, setActiveJoint] = useState(
    stepData.joints[0]?.joint_id
  );

  // ✅ Store values: jointId → movementId → value
  const [values, setValues] = useState<any>({});

  // ✅ Movement map
  const movementMap = useMemo(() => {
    const map: any = {};
    stepData.movement.forEach((m: any) => {
      if (!map[m.joint_id]) map[m.joint_id] = [];
      map[m.joint_id].push(m);
    });
    return map;
  }, [stepData.movement]);

  // ✅ Handle value change
  const handleValueChange = (
    jointId: string,
    movementId: string,
    value: any
  ) => {
    setValues((prev: any) => ({
      ...prev,
      [jointId]: {
        ...prev[jointId],
        [movementId]: value,
      },
    }));
  };

  // ✅ Submit format
  const handleSubmit = (endpoint: string) => {
    const payload: any[] = [];

    Object.keys(values).forEach((jointId) => {
      Object.keys(values[jointId]).forEach((movementId) => {
        payload.push({
          joint: jointId,
          movement: movementId,
          value: parseFloat(values[jointId][movementId]),
        });
      });
    });

    onSubmit(endpoint, payload);
  };

  return (
    <div>
      <h6>{stepData.display_title}</h6>

      <div className="row">

        {/* ✅ LEFT: JOINT LIST */}
        <div className="col-4">
          <ul className="list-group">
            {stepData.joints.map((joint: any) => (
              <li
                key={joint.joint_id}
                className={`list-group-item ${activeJoint === joint.joint_id ? "active" : ""
                  }`}
                style={{ cursor: "pointer" }}
                onClick={() => setActiveJoint(joint.joint_id)}
              >
                {joint.joint_name}
              </li>
            ))}
          </ul>
        </div>

        {/* ✅ RIGHT: MOVEMENTS TABLE */}
        <div className="col-8">
          <table className="table">
            <thead>
              <tr>
                <th>Movement</th>
                <th>Value</th>
              </tr>
            </thead>

            <tbody>
              {(movementMap[activeJoint] || []).map((move: any) => (
                <tr key={move.movement_id}>
                  <td>{move.movement_name}</td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      value={
                        values[activeJoint]?.[move.movement_id] || ""
                      }
                      onChange={(e) =>
                        handleValueChange(
                          activeJoint,
                          move.movement_id,
                          e.target.value
                        )
                      }
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* ✅ Actions */}
      <div className="d-flex justify-content-end mt-3">
        {stepData.actions.map((action: any, i: number) => {
          if (action.action_type === "SUBMIT_DATA") {
            return (
              <button
                key={i}
                type="button"
                className="btn btn-primary"
                onClick={() => handleSubmit(action.endpoint)}
              >
                {action.label}
              </button>
            );
          }

          if (action.action_type === "SUBMIT_EMPTY") {
            return (
              <button
                key={i}
                type="button"
                className="btn btn-secondary me-2"
                // onClick={() => onSubmit(action.endpoint, [])}
                onClick={() => onSkip(assessId,stepId)}
              >
                {action.label}
              </button>
            );
          }

          return null;
        })}
      </div>
    </div>
  );
};

export default RangeOfMotion;